import { render } from "./Element.vue?vue&type=template&id=867a9ab2&scoped=true"
const script = {}

import "./Element.vue?vue&type=style&index=0&id=867a9ab2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867a9ab2"]])

export default __exports__